

 let spImgList = [
    "https://cdn.shopify.com/s/files/1/0649/5109/1437/files/1_7d538745-bb6a-4f13-a7cf-fc9c1737f79b.jpg?v=1766980818",
    "https://cdn.shopify.com/s/files/1/0649/5109/1437/files/5_eabc506f-b0f8-4510-80bd-4f9886be5701.jpg?v=1766980818",
    "https://cdn.shopify.com/s/files/1/0649/5109/1437/files/2_06a253b7-d31e-4ba0-8f9a-844e642a3354.jpg?v=1766980818",
    "https://cdn.shopify.com/s/files/1/0649/5109/1437/files/6_49c2c42b-a4b4-43c9-863a-645c9bdd4edc.jpg?v=1766980817",
    "https://cdn.shopify.com/s/files/1/0649/5109/1437/files/3_fbbc7ed3-ceba-4dd6-af8b-a5c5ec8c899e.jpg?v=1766980817",
    "https://cdn.shopify.com/s/files/1/0649/5109/1437/files/7.jpg?v=1766980818",
    "https://cdn.shopify.com/s/files/1/0649/5109/1437/files/4.jpg?v=1766980818",
    "https://cdn.shopify.com/s/files/1/0649/5109/1437/files/8.jpg?v=1766980818",
  ];
  function getCur(){
    const prods = window.product_11
  let color = $('#sp-color div.active').attr('data-val')
  let num = $('#sp-num div.active').attr('data-val')
  return prods.filter(item=> item.option1 == color && item.option2 == num )[0]
}
function changePrice(){
  let num = $('#calcNumber').val()
  let price = (getCur().price * num / 100).toFixed(2)
  let compare = (getCur().compare_at_price * num / 100).toFixed(2)
  price = (price + '').replace('.', ',')
  compare = (compare + '').replace('.', ',')
  $('#sp_price1').html(price)
  $('#sp_price2').html(compare)
  let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
  $(".product-part .price-group .sp-row span").html(off_font);
}
$('.sp-btn-style').on('click',function(){
  let id = getCur().id
  let num = $("#calcNumber").val();
  window.location.href = '/cart/' + id + ':' + num
})

$(".sp-reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    if (num > 0) {
      input.value = num;
    }
    changePrice()
  });
  $(".sp-add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
    changePrice()
  });

  let _spcolor = ["#55392E", "#8F523A", "#672C1E", "#655A58", "#111111"];
  $(".sp-option").click(function () {
    debugger
    $(this).siblings().removeClass("active");
    $(this).addClass("active");

    let colorOptions = $("#sp-color .sp-option.active").index();
    let numOptions = $("#sp-num .sp-option.active").index();

    _index = colorOptions * 4 + numOptions;

    $(".product-part  .sp-img-p")[0].src = spImgList[_index];

    // _swiper.slideToLoop(_index);
    changePrice()
  });

  $(function () {
    let initNum = 0;
    $(".product-part .cart-btn").click(function () {
      let spNum = $(".product-part #calcNumber")[0].value;
    //   initNum += Number(spNum);

    //   // $("#calcNumber").val(1);
    //   $("#cardNum").html(initNum);
    let data = {
      id: getCur().id,
      quantity: $("#calcNumber").val()
    };
    $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        success: function () {
        $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
            $("#cardNum").html(result.item_count);
            $("#cardNum").removeClass("sp-gray");
        });
        },
        dataType: "json",
    });
      
      // handleAddToCart(initNum);

      // var imgs = $(".product-part .swiper-slide-active").find("img");
    //   var imgs = $(".product-part .sp-img-p");
    });
  });

